// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Fx from "./src/fx/fx.jsx";
import * as Routes__Album from "./src/routes/album.jsx";
import * as Routes__Artist from "./src/routes/artist.jsx";
import * as Routes__Artists from "./src/routes/artists.jsx";
import * as Routes__LayoutRoute from "./src/routes/layoutRoute.jsx";
import * as Routes__Login from "./src/routes/login.jsx";
import * as Routes__Root from "./src/routes/root.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as Store from "./src/store/store.jsx";
import * as StoreFx__SubscribeToStoreStateUpdates from "./src/storeFx/subscribeToStoreStateUpdates.jsx";
import * as Store__Context from "./src/store/context.jsx";
import * as React from "react";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";

function setStyle(style, name, value) {
  style.setProperty(name, value, "");
}

const container = document.createElement("div");

const partial_arg = container.style;

function setContainerStyle(param, param$1) {
  return setStyle(partial_arg, param, param$1);
}

Curry._2(setContainerStyle, "width", "100%");

Curry._2(setContainerStyle, "height", "100%");

Curry._2(setContainerStyle, "overflow", "scroll");

Curry._2(setContainerStyle, "position", "absolute");

Curry._2(setContainerStyle, "inset", "0");

Curry._2(setContainerStyle, "z-index", "-9999");

Curry._2(setContainerStyle, "visibility", "hidden");

const $$document = document;

Stdlib__Option.get(Caml_option.nullable_to_opt($$document.body)).appendChild(container);

new ResizeObserver((function (entries) {
      const entry = entries[0];
      const documentElement = $$document.documentElement;
      const borderBoxSize = entry.borderBoxSize[0];
      const contentBoxSize = entry.contentBoxSize[0];
      const partial_arg = documentElement.style;
      const setHtmlStyle = function (param, param$1) {
        return setStyle(partial_arg, param, param$1);
      };
      Curry._2(setHtmlStyle, "--scrollbar-inline-size", (borderBoxSize.inlineSize - contentBoxSize.inlineSize).toString(undefined) + "px");
      Curry._2(setHtmlStyle, "--scrollbar-block-size", (borderBoxSize.blockSize - contentBoxSize.blockSize).toString(undefined) + "px");
    })).observe(container);

const store = Store.make(undefined);

const routeTree = Routes__Root.route.addChildren([
  Routes__Login.route,
  Routes__LayoutRoute.route.addChildren([
    Routes__Album.route,
    Routes__Artist.route,
    Routes__Artists.route
  ])
]);

const router = ReactRouter.createRouter({
  context: {
    store: store
  },
  defaultPreload: "intent",
  routeTree: routeTree,
  scrollRestoration: true
});

store.subscribe(function (state, prevState) {
  if (state.auth.credentials !== prevState.auth.credentials) {
    router.invalidate();
    return;
  }
  
});

Fx.runAsync(StoreFx__SubscribeToStoreStateUpdates.make(undefined), {
  store: store
}).then(function (result) {
  return Promise.resolve(Stdlib__Result.get_ok(result));
});

Client.createRoot(Stdlib__Option.get(Caml_option.nullable_to_opt(document.querySelector("#app")))).render(JsxRuntime.jsx(React.StrictMode, {
  children: JsxRuntime.jsx(Store__Context.Provider.make, {
    children: JsxRuntime.jsx(ReactRouter.RouterProvider, {
      router: router
    }),
    store: store
  })
}));
/* container Not a pure module */
